import { Component, Input, Output, OnInit, OnChanges, SimpleChanges, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { Direction, DocumentTypeEntity, DocumentConfig, DocumentConfigSearchDisplay } from '../models';
import { DeveloperService } from '../../developer/services/developer.service';
import { BatchingConfiguration } from '../../developer/models/batchconfiguration';
import { DistributionService } from '../services/distribution.service';
import { DocumentConfigOutBatcher } from '../../developer/models/document-config-out-batcher';
import { Distribution } from '../models/distribution';
import { forkJoin as observableForkJoin, Observable, BehaviorSubject } from 'rxjs';
import { FilenamingType } from '../models/filenaming-type';
import { DxLookupModule } from 'devextreme-angular';
import { DxoDropDownOptionsModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'ep-batching-selector',
    templateUrl: './batching-selector.component.html',
    styleUrls: ['./batching-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxLookupModule, DxoDropDownOptionsModule, DxTemplateModule, FormsModule, AsyncPipe]
})
export class BatchingSelectorComponent implements OnInit, OnChanges {
    @Input() documentConfig: DocumentConfig = null;
    @Input() distribution: Distribution = null;
    @Input() isEditing = false;


    public batchingConfigurations: BatchingConfiguration[];
    public selectedBatchingConfiguration: BatchingConfiguration;
    public docConfigOutBatchers: DocumentConfigOutBatcher[];
    public selectedConfigOutBatcher: DocumentConfigOutBatcher;
    public filenamingTypes: BehaviorSubject<FilenamingType[]> = new BehaviorSubject<FilenamingType[]>([]);


    constructor(
        private developerService: DeveloperService,
        private distributionService: DistributionService) { }

    async ngOnInit() {
        await this.refresh();
    }

    findFilenamingTypes() {
        if (this.distribution?.DocumentConfigIn?.DistributionObject) {
            return this.distributionService.getFilenamingTypes(this.distribution.DocumentConfigIn.DistributionObject.Id).then((filenamingTypes) => {
                this.filenamingTypes.next(filenamingTypes);
            });
        }
        else {
            return Promise.resolve();
        }
    }

    async ngOnChanges(changes: SimpleChanges) {
        await this.refresh();
    }

    public async refresh() {
        if (this.documentConfig) {
            this.batchingConfigurations = await this.distributionService.getBatchingConfigurationsByDocumentType(this.documentConfig.DistributionObject.Id);
            this.docConfigOutBatchers = await this.developerService.getDocumentConfigOutBatchers(this.documentConfig.DocumentConfigsId);
            if (this.distribution.DocumentConfigOutBatchersId != null) {
                this.selectedConfigOutBatcher = this.docConfigOutBatchers.find(x => x.Id === this.distribution.DocumentConfigOutBatchersId);
            }
            if (this.distribution.BatchingConfigurationsId != null) {
                this.selectedBatchingConfiguration = this.batchingConfigurations.find(x => x.Id === this.distribution.BatchingConfigurationsId);
            }
            this.findFilenamingTypes();
        }
    }

    public async reset() {
        await this.refresh();
    }






    displayExprBatcher(item: DocumentConfigOutBatcher) {
        return item?.ArtifactName || 'Please select...';
    }

    displayExprBatchConfig(item: BatchingConfiguration) {
        return item?.Name || 'Please select...';
    }

    artifactSelectedInternal(e: any): void {
        this.selectedConfigOutBatcher = e.value as DocumentConfigOutBatcher;
    }

    batchConfigSelectedInternal(e: any): void {
        this.selectedBatchingConfiguration = e.value as BatchingConfiguration;
    }

}

